import React, { useState, useEffect, useRef } from 'react';
import { Button, Collapse, Form, Container } from 'react-bootstrap';
import './filter.scss';

const Filter = ({ items, filter, onFilterChange }) => {
    const [issuerOpen, setIssuerOpen] = useState(false);
    const [isinOpen, setIsinOpen] = useState(false);
    const [statusOpen, setStatusOpen] = useState(false);

    const [issuers, setIssuers] = useState(filter.issuers || []);
    const [isins, setIsins] = useState(filter.isins || []);
    const [statuses, setStatuses] = useState(filter.status || []);

    // Debounce filter updates
    const debounceRef = useRef(null);

    useEffect(() => {
        // console.log("Issuers:", issuers);
        // console.log("ISINs:", isins);
        // console.log("Statuses:", statuses);

        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => {
            onFilterChange({
                issuers,
                isins,
                status: statuses,
            });
        }, 300);
    }, [issuers, isins, statuses, onFilterChange]);

    const handleIssuerChange = (e) => {
        const { value, checked } = e.target;
        setIssuers((prevIssuers) => 
            checked ? [...prevIssuers, value] : prevIssuers.filter((issuer) => issuer !== value)
        );
    };

    const handleIsinChange = (e) => {
        const { value, checked } = e.target;
        // console.log(`ISIN Changed: ${value}, Checked: ${checked}`); // Log the ISIN change event
        setIsins((prevIsins) => 
            checked ? [...prevIsins, value] : prevIsins.filter((isin) => isin !== value)
        );
    };

    const handleStatusChange = (e) => {
        const { value, checked } = e.target;
        setStatuses((prevStatuses) => 
            checked ? [...prevStatuses, value] : prevStatuses.filter((status) => status !== value)
        );
    };

    const clearFilter = () => {
        setIssuers([]);
        setIsins([]);
        setStatuses([]);
        onFilterChange({
            issuers: [],
            isins: [],
            status: [],
        });
    };

    const uniqueIssuers = Array.from(new Set(items.map(item => item.issuer)));
    const uniqueIsins = Array.from(new Set(items.map(item => item.isin)));
    const uniqueStatuses = Array.from(new Set(items.map(item => item.status)));

    return (
        <Container className="filter-container">
            <Button onClick={clearFilter} variant="outline-primary" className="mb-3">
                Clear Filter
            </Button>

            <Form>
                {/* Issuer Filter */}
                <Form.Group controlId="issuerFilter" className="bordered-group">
                    <Button 
                        onClick={() => setIssuerOpen(!issuerOpen)} 
                        aria-controls="issuer-collapse" 
                        aria-expanded={issuerOpen}
                        variant="outline-secondary"
                        className="w-100 text-left no-border statusFilterButton"
                    >
                        Issuer
                        <span className={`arrow ${issuerOpen ? 'up' : 'down'}`}></span>
                    </Button>
                    <Collapse in={issuerOpen}>
                        <Container className={`collapseContainer ${issuerOpen ? 'expanded' : 'collapsed'}`}>
                            <div id="issuer-collapse" className="mt-2">
                                {uniqueIssuers.map((issuer, index) => (
                                    <Form.Check 
                                        key={`issuer-${index}`}
                                        id={`issuer-${index}`}
                                        type="checkbox" 
                                        value={issuer}
                                        label={issuer}
                                        checked={issuers.includes(issuer)}
                                        onChange={handleIssuerChange}
                                    />
                                ))}
                            </div>
                        </Container>
                    </Collapse>
                </Form.Group>

                {/* ISIN Filter */}
                <Form.Group controlId="isinFilter" className="bordered-group">
                    <Button 
                        onClick={() => setIsinOpen(!isinOpen)} 
                        aria-controls="isin-collapse" 
                        aria-expanded={isinOpen}
                        variant="outline-secondary"
                        className="w-100 text-left no-border statusFilterButton"
                    >
                        ISIN
                        <span className={`arrow ${isinOpen ? 'up' : 'down'}`}></span>
                    </Button>
                    <Collapse in={isinOpen}>
                        <Container className={`collapseContainer ${isinOpen ? 'expanded' : 'collapsed'}`}>
                            <div id="isin-collapse" className="mt-2">
                                {uniqueIsins.map((isin, index) => (
                                    <Form.Check 
                                        key={`isin-${index}`}
                                        id={`isin-${index}`}
                                        type="checkbox" 
                                        value={isin}
                                        label={isin}
                                        checked={isins.includes(isin)}
                                        onChange={handleIsinChange}
                                    />
                                ))}
                            </div>
                        </Container>
                    </Collapse>
                </Form.Group>

                {/* Status Filter */}
                <Form.Group controlId="statusFilter" className="bordered-group">
                    <Button 
                        onClick={() => setStatusOpen(!statusOpen)} 
                        aria-controls="status-collapse" 
                        aria-expanded={statusOpen}
                        variant="outline-secondary"
                        className="w-100 text-left no-border statusFilterButton"
                    >
                        Status
                        <span className={`arrow ${statusOpen ? 'up' : 'down'}`}></span>
                    </Button>
                    <Collapse in={statusOpen}>
                        <Container className={`collapseContainer ${statusOpen ? 'expanded' : 'collapsed'}`}>
                            <div id="status-collapse" className="mt-2">
                                {uniqueStatuses.map((status, index) => (
                                    <Form.Check 
                                        key={`status-${index}`}
                                        id={`status-${index}`}
                                        type="checkbox" 
                                        value={status}
                                        label={`${status} (${items.filter(item => item.status === status).length})`}
                                        checked={statuses.includes(status)}
                                        onChange={handleStatusChange}
                                    />
                                ))}
                            </div>
                        </Container>
                    </Collapse>
                </Form.Group>

            </Form>
        </Container>
    );
};

export default Filter;
